import { render, staticRenderFns } from "./AuthBase.vue?vue&type=template&id=58194198&scoped=true&"
import script from "./AuthBase.vue?vue&type=script&lang=js&"
export * from "./AuthBase.vue?vue&type=script&lang=js&"
import style0 from "./AuthBase.vue?vue&type=style&index=0&id=58194198&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58194198",
  null
  
)

export default component.exports